exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tab-bar{background-color:#fff;margin-bottom:1.5rem;margin-left:-1.5rem;margin-right:-1.5rem;padding-left:1.5rem;padding-right:1.5rem}.tab-bar a>span{padding:.75rem .875rem;display:inline-block;font-size:.875rem;font-family:Hind Medium;color:#565656;border-top:2px solid #fff;transition:all .3s ease}.tab-bar a>span:hover{background-color:#f8f8f8;border-top:2px solid #f8f8f8}.tab-bar a.router-link-active>span{background-color:#f8f8f8;color:#243c98;border-top:2px solid #243c98;border-radius:2px}.active-top,.is-active{border-top:2px solid #243c98}.is-active{background-color:#f8f8f8;color:#243c98;border-radius:2px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-3fb9e760","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/TabBar.vue
// module id = 744
// module chunks = 0